globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.SelectMediaImage = (function(superClass) {

  utils.extend(SelectMediaImage, superClass);

  function SelectMediaImage() {
    this.uploadPath = '/configuration/mediatheque/images/upload';

    return SelectMediaImage.__super__.constructor.apply(this, arguments);
  }

  $.extend(SelectMediaImage.prototype, {
    init: function() {
      return SelectMediaImage.__super__.init.apply(this, arguments);
    },
    _initSelectedMediaData: function(){
      var modal = this;
      if(modal.$selectedMediaAbstractFile.length) {
        modal.selectedMediaImageData = {
          id: modal.$selectedMediaAbstractFile.data('id'),
          type: modal.$selectedMediaAbstractFile.data('type'),
          medium_url: modal.$selectedMediaAbstractFile.data('medium-url'),
          mini_url: modal.$selectedMediaAbstractFile.data('mini-url')
        }
      }
    },
    _selectMediaAbstractFile: function($mediaImage) {
      var modal = this,
          $selectedMediaImage = modal.$selectedFileContainer.find('.thumbnail');

      appCustomerSpace.Loader().start({ $container: modal.$selectedFileContainer, options: {text: ''} });

      if(!$selectedMediaImage.length) $selectedMediaImage = modal._selectedMediaAbstractFileTemplate();

      modal.selectedMediaImageData = {
        id: $mediaImage.data('id'),
        type: $mediaImage.data('type'),
        medium_url: $mediaImage.data('medium-url'),
        mini_url: $mediaImage.data('mini-url')
      }

      modal.$mediaAbstractFilesContainer.find('.file-item').removeClass('selected');
      $mediaImage.addClass('selected');

      if($selectedMediaImage.length) {
        $selectedMediaImage.find('img').attr('src', modal.selectedMediaImageData.medium_url);
        modal.$selectedFileContainer.html($selectedMediaImage);
      }
    },
    _submit: function(){
      var modal = this,
          $fieldContainer = $(`#${modal.options.data.preview_dom_id}`);

      modal.options.data.image_id = modal.selectedMediaImageData.id;

      if($fieldContainer.length) {
        $fieldContainer.find('img').attr('src', modal.selectedMediaImageData.medium_url).end()
                       .find('input.file-id[type=hidden]').val(modal.selectedMediaImageData.id).trigger('change').end()
                       .find('input.file-type[type=hidden]').val(modal.selectedMediaImageData.type).end()
                       .find('.btn.delete.disabled').removeClass('disabled')
                       .find('.open-modal').attr('data-modal-options', JSON.stringify(modal.options))

        modal.close();
      }
    }
  });

  return SelectMediaImage;

})(appCustomerSpace.Modals.Settings.SelectMediaAbstractFile);
